var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 75,
    viewBox: "0 0 62 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.044 1.14946L40.8678 0.027832H20.4339L18.2577 1.14946L14.5489 6.69161H0V74.7527H61.3017V6.69161H46.7528L43.044 1.14946ZM17.3688 11.4043L20.5156 6.69161L21.8234 4.74055H39.4477L40.7554 6.69161L43.9022 11.4043L45.4859 13.7607H15.8567L17.3688 11.4043ZM56.1932 11.4043V70.0399H5.10848V11.4043H11.3919L9.06244 14.8823L11.2386 18.4734H50.0631L52.2393 14.8823L49.9098 11.4043H56.1932Z",
    fill: "#00755F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5296 28.0117H28.0957V30.8393H48.5296V28.0117Z",
    fill: "#00755F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.518 30.6043L14.0978 28.3139L11.4414 29.7089L15.3852 36.0805L22.1386 26.2592L19.5435 24.7417L15.518 30.6043Z",
    fill: "#00755F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5296 42.0562H28.0957V44.8838H48.5296V42.0562Z",
    fill: "#00755F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.518 44.6478L14.0978 42.3574L11.4414 43.7618L15.3852 50.1334L22.1386 40.3027L19.5435 38.7852L15.518 44.6478Z",
    fill: "#00755F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5296 56.0996H28.0957V58.9272H48.5296V56.0996Z",
    fill: "#00755F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.518 58.6916L14.0978 56.4012L11.4414 57.8056L15.3852 64.1772L22.1386 54.3464L19.5435 52.8384L15.518 58.6916Z",
    fill: "#00755F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.1c935d122b7d413312951735a3892cdb.svg";
export { ForwardRef as ReactComponent };